module.exports = __webpack_public_path__ + "static/img/user.73baa6f6.png";